import request from '../utils/request';

//获取班级数据
export function getClassInfo(data) {
  return request({
    url: '/wap/class/toClassDetail.html',
    method: 'post',
    data
  })
}

//购买
export function toGenerateOrder(data) {
  return request({
    url: '/wap/tyOrder/toGenerateOrder.do',
    method: 'post',
    data
  })
}

//课程详情
export function toCourseDetail(data) {
  return request({
    url: '/wap/class/toCourseDetail.html',
    method: 'post',
    data
  })
}

//试听
export function toTryLookCourse(data) {
  return request({
    url: '/wap/class/toTryLookCourse.html',
    method: 'post',
    data
  })
}

//购买成功后获取订单数据
export function toPaySuccess(data) {
  return request({
    url: '/wap/tyOrder/toPaySuccess.do',
    method: 'post',
    data
  })
}